module.exports = __webpack_public_path__ + "9ba2ece4bbaa7136192b287c3d60a63e.svg";


//////////////////
// WEBPACK FOOTER
// ./components/applications/success/ads/lemonade/lemonade.svg
// module id = 1119
// module chunks = 0